import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { wagerListItem } from './wagerListItem.js';

export const wagersResponseSchema = z
  .object({
    wagers: z.array(wagerListItem),
    moreItems: z.boolean(),
  })
  .transform(({ wagers, moreItems: hasMoreItems }) => ({ data: { wagers, hasMoreItems } }));

export const wagersApiResponse = {
  parse: (data: unknown) => z.union([wagersResponseSchema, apiErrorSchema]).parse(data),
} as const;
